module.exports = __webpack_public_path__ + "static/img/00029A_2_3_R_20190322_fit.8d0b6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00029A_2_3_R_20190322_fit.png
// module id = o9zq
// module chunks = 0